import Slider, { Settings } from 'react-slick';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { colours } from '../../StyleConstants';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import "./carousel.css";

const Carousel = (props: Settings) => {
    return (
        <Slider
            {...props}
            prevArrow={<ChevronLeftIcon sx={{ color: colours.action.active, height: "35px", width: "35px" }}/>}
            nextArrow={<ChevronRightIcon sx={{ color: colours.action.active, height: "35px", width: "35px" }}/>}
        >
            {props.children}
        </Slider>
    )
}

export default Carousel;